var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.list,"scroll":{ x: 0, y: _vm.y },"pagination":false,"loading":_vm.listLoading,"destroyOnClose":true,"forceRender":true,"rowClassName":_vm.rowClassName},scopedSlots:_vm._u([{key:"rawName",fn:function(text,record){return [_vm._v(" "+_vm._s(_vm.overseasFlag == '1' ? (record.aliasName || text) : text)+" ")]}},_vm._l((['percentage', 'productPercentage']),function(col){return {key:col,fn:function(text){return [_vm._v(" "+_vm._s(_vm._f("numberFixed")(text,3))+" ")]}}}),{key:"difference",fn:function(text, record){return [_c('span',{class:{
        red: Number((record.percentage || 0) - (record.productPercentage || 0)) > 0,
        green: Number((record.percentage || 0) - (record.productPercentage || 0)) < 0
      }},[_vm._v(" "+_vm._s(_vm.getNum(record))+" ")])]}},{key:"cast",fn:function(text, record){return [_c('span',{class:{
        red:
          (record.percentage - record.productPercentage) /
            record.productPercentage >
          0,
        green:
          (record.percentage - record.productPercentage) /
            record.productPercentage <
          0
      }},[_vm._v(" "+_vm._s(text)+" ")])]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }